import OfferOrderForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    OfferOrderForm
  },
  props: {
    demandData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.orderid': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('leadtrade.offerOrder.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false

      API.offerPurchase.order.show(this.$route.params.orderid).then(response => {
        this.data = response.data

        this.$setBreadcrumbs([
          {
            label: this.$t('breadcrumbs.offer-and-demand.index'),
            route: {name: 'offer-and-demand-index'}
          },
          {
            label: this.$t('breadcrumbs.offer-order.index'),
            route: {name: 'offer-order-index'}
          },
          {
            label: this.$t('breadcrumbs.offer-order.edit',
              {
                name: ''
              }),
            route: {}
          }
        ])

        this.ready = true
      })
    },

    updateOffer(data) {
      API.offerPurchase.order.update(this.$route.params.orderid, data).then(() => {
        this.$notifications.success(this.$t('leadtrade.offerOrder.edit.succesfullyUpdated'))
        this.$router.push({name: 'offer-order-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
